import { render, staticRenderFns } from "./ConfirmationModel.vue?vue&type=template&id=871dc5da&scoped=true"
import script from "./ConfirmationModel.vue?vue&type=script&lang=js"
export * from "./ConfirmationModel.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationModel.vue?vue&type=style&index=0&id=871dc5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871dc5da",
  null
  
)

export default component.exports